/**
 * TwinDrillSection (P51.1) -- "View in Twin" link rendered inside
 * an admin entity drawer's extraSections slot.
 *
 * Closes the orphaned-route gap for /twin/vendor/:id and
 * /twin/ci/:id (P50 audit finding). The admin drawer edit-mode
 * gets a small footer link to the Twin-side detail page so
 * operators can drill from "I'm editing this vendor row" to
 * "show me the Twin-side state for this vendor" in one click.
 *
 * Factory shape so each adapter exports its own typed section
 * pointing at the right /twin/{kind}/:id route. The shared
 * extraSection shape on `EntityAdapter` is `(props: { rowId: string }) => ReactNode`.
 */
import { i18n } from "shared/i18n";
import { Link } from "react-router-dom";

import type { EntityKind } from "shared/api/types";

const TWIN_ROUTE_BY_KIND: Record<EntityKind, string> = {
  ibs_service: "/twin/ibs",
  service: "/twin/service",
  capability: "/twin/capability",
  vendor: "/twin/vendor",
  configuration_item: "/twin/ci",
};

export function makeTwinDrillSection(kind: EntityKind, testid: string) {
  return function TwinDrillSection({ rowId }: { rowId: string }) {
    return (
      <section
        data-testid={`${testid}-section`}
        className="rounded border border-slate-200 bg-white px-3 py-2"
      >
        <h3 className="text-[10px] font-semibold uppercase tracking-widest text-slate-500">
          {i18n.t("screens.twinDrillSection.twin")}
        </h3>
        <Link
          to={`${TWIN_ROUTE_BY_KIND[kind]}/${rowId}`}
          data-testid={testid}
          className="mt-1 inline-block rounded border border-brand-brass/40 bg-brand-brass/5 px-2 py-0.5 text-[10px] font-semibold text-brand-brassDark hover:bg-brand-brass/10"
        >
          {i18n.t("screens.twinDrillSection.viewInTwinRarr")}
        </Link>
      </section>
    );
  };
}
